import { createSlice } from '@reduxjs/toolkit';
import { getReportTemplatesByIdApi } from '../../../rtk-apis/reports/getReportTemplateById';

const initialState = {
  status: '',
  result: '',
  msg: '',
  loading: false,
};

const getReportTemplatesByIdSlice = createSlice({
  name: 'getReportTemplates',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getReportTemplatesByIdApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getReportTemplatesByIdApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.msg = action?.payload?.msg;
        state.result = action?.payload;
      })
      .addCase(getReportTemplatesByIdApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.msg = action?.payload as string;
        state.result = (action?.payload as string) || '';
      });
  },
});

export const { clearState } = getReportTemplatesByIdSlice.actions;
export default getReportTemplatesByIdSlice.reducer;
